import * as React from 'react'

import DonationApp from './components/DonationApp'

export default function App () {
  return (
    <main>
      <DonationApp/>
    </main>
  )
}
